/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Obligations_S41_Item_4Inputs */

const es_tyc_obligations_s41_item_4 = /** @type {(inputs: Tyc_Obligations_S41_Item_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cumplir con las politicas de su Inquilino y las leyes aplicables.`)
};

const en_tyc_obligations_s41_item_4 = /** @type {(inputs: Tyc_Obligations_S41_Item_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comply with your Tenant policies and applicable laws.`)
};

/**
* | output |
* | --- |
* | "Comply with your Tenant policies and applicable laws." |
*
* @param {Tyc_Obligations_S41_Item_4Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_obligations_s41_item_4 = /** @type {((inputs?: Tyc_Obligations_S41_Item_4Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Obligations_S41_Item_4Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_obligations_s41_item_4(inputs)
	return en_tyc_obligations_s41_item_4(inputs)
});
export { tyc_obligations_s41_item_4 as "tyc.obligations.s41_item_4" }